module.exports = __webpack_public_path__ + "img/icon-download.ff7bfed7.svg";